import React, { Component } from "react";
import { UploadPanel } from "../components";
import { constant } from "../helpers";
import "./Site.css";
import { Redirect } from "react-router-dom";

export default class InventoryUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToDashboard: false
    };
  }

  render() {
    if (this.state.redirectToDashboard) {
      return <Redirect to="/home" />;
    }

    return (
      <div>
        <UploadPanel
          uploadType={constant.uploadType.inventory}
          onSuccess={() => this.setState({ redirectToDashboard: true })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InventoryUpload.js